import { render, staticRenderFns } from "./weekDashboardEducation.vue?vue&type=template&id=3544ee34"
import script from "./weekDashboardEducation.vue?vue&type=script&lang=js"
export * from "./weekDashboardEducation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3544ee34')) {
      api.createRecord('3544ee34', component.options)
    } else {
      api.reload('3544ee34', component.options)
    }
    module.hot.accept("./weekDashboardEducation.vue?vue&type=template&id=3544ee34", function () {
      api.rerender('3544ee34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/week/weekDashboardEducation.vue"
export default component.exports